// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Collections'"></sub-header>
  <collections-filter
    search-by="\$ctrl.searchBy"
    individual-filter="\$ctrl.individualFilter"
    group-filter="\$ctrl.groupFilter">
  </collections-filter>

  <collections-payment
    search-by="\$ctrl.searchBy"
    individual-filter="\$ctrl.individualFilter"
    group-filter="\$ctrl.groupFilter">
  </collections-payment>
</section>

`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/dashboard/collections/collections.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;